import { useCallback, useEffect, useState } from "react"
import MarcasOutput from "../../models/marcas/MarcasOutput"
import http from "../../../../http"
import { useRecarregaAoRenovarToken } from "../../../shared/hooks/useRecarregaAoRenovarToken"

export const useBuscaListaMarcas = () => {
    const [listaMarcas, setListaMarcas] = useState(MarcasOutput.create([]))

    const buscaListaMarcas = useCallback(() => {
        http.get('/brands')
            .then(res => {
                const resposta = res.data
                const listaMarcas = MarcasOutput.create(resposta)
                setListaMarcas(listaMarcas)
            })
            .catch(() => setListaMarcas(MarcasOutput.create([])))
    }, [])

    useEffect(() => {
        buscaListaMarcas()
    }, [buscaListaMarcas])

    useRecarregaAoRenovarToken(buscaListaMarcas)

    return {
        listaMarcas,
    }
}
